import { Component, createRef } from 'react';
import * as React from 'react';
import { withTheme } from 'styled-components';

import {
Container,
TextContainer,
ChildrenContainer,
Wrap,
Text,
Triangles,
Sides,
SnapPositions,
AnimationContainer } from "./styled";


/* istanbul ignore file */

const triangleHeight = 12;
const triangleWidth = 24;
const expectedMargin = 8;
const maxWidthPointer = 384;

























class Pointer extends Component {
  constructor(props) {
    super(props);this.














    childrenContainerRef = /*#__PURE__*/createRef();this.
    textContainerRef = /*#__PURE__*/createRef();this.






    getViewport = () => {
      const { scrollY, scrollX, innerHeight, innerWidth } = window;
      const viewport = {
        scrollX,
        scrollY,
        innerHeight,
        innerWidth };


      return viewport;
    };this.

    setPointerPosition = () => {
      const rects = this.getRects();
      const viewport = this.getViewport();

      if (rects) {
        const pointerWidth = rects.textRect.width;
        const childrenWidth = rects.childrenRect.width;
        const requiredVerticalSpace = rects.textRect.height + triangleHeight + expectedMargin;
        const spaceLeft = rects.childrenRect.left - expectedMargin;
        const spaceRight = viewport.innerWidth - rects.childrenRect.right - expectedMargin;
        const spaceTop = rects.childrenRect.top - requiredVerticalSpace;
        const spaceBottom =
        viewport.innerHeight - rects.childrenRect.bottom - requiredVerticalSpace;
        const centeringOffset = (pointerWidth - childrenWidth) / 2;
        const shouldShowCentered =
        window.innerWidth >= pointerWidth + 2 * expectedMargin &&
        spaceLeft > centeringOffset &&
        spaceRight > centeringOffset;
        const topOffset = triangleHeight + 8;
        const bottomOffset = rects.childrenRect.height + triangleHeight + 8;
        const shouldShowChildrenOnly = pointerWidth > viewport.innerWidth;

        const snapPosition = spaceLeft > spaceRight ? SnapPositions.RIGHT : SnapPositions.LEFT;

        const shouldShowOnTop = spaceTop > spaceBottom;

        const pointerOffset = shouldShowCentered ? -centeringOffset : 0;
        const verticalOffset = shouldShowOnTop ? topOffset : bottomOffset;
        const arrowOffset = Math.abs(pointerOffset) + (childrenWidth - triangleWidth) / 2;

        const pointerLeftDistance = rects.childrenRect.left - Math.abs(pointerOffset);
        const roundedPointerwidth = Math.round(pointerWidth);
        const sizePointerSpace = roundedPointerwidth + pointerLeftDistance;
        if (sizePointerSpace >= window.innerWidth) {
          const availableWidth = window.innerWidth - 3 * expectedMargin - pointerLeftDistance;
          this.setState({ calculatedPointerWidth: availableWidth });
        } else {
          this.setState({ calculatedPointerWidth: roundedPointerwidth });
        }

        const textWrap = !!(
        sizePointerSpace >= window.innerWidth || sizePointerSpace >= maxWidthPointer);


        this.setState({
          pointerOffset,
          verticalOffset,
          arrowOffset,
          snapPosition,
          side: shouldShowOnTop ? Sides.TOP : Sides.BOTTOM,
          shouldShowChildrenOnly,
          textWrap });

      }
    };this.

    getRects = () => {
      const { childrenContainerRef, textContainerRef } = this;

      if (childrenContainerRef.current && textContainerRef.current) {
        const [childrenContainer, tipContainer] = [
        childrenContainerRef.current,
        textContainerRef.current];

        const childrenRect = childrenContainer.getBoundingClientRect();
        const textRect = tipContainer.getBoundingClientRect();

        return { childrenRect, textRect };
      }

      return false;
    };this.

    setRects = () => {
      const rects = this.getRects();

      if (rects) {
        this.setState({ rects });
      }
    };this.state = { shouldShowChildrenOnly: false, side: Sides.TOP, snapPosition: SnapPositions.LEFT, pointerOffset: 0, verticalOffset: 0, arrowOffset: 0, textWrap: false, calculatedPointerWidth: 0, rects: false };}componentDidMount() {this.setRects();this.setPointerPosition();}

  render() {
    const { children, text, theme, zIndex } = this.props;
    const {
      side,
      pointerOffset,
      arrowOffset,
      snapPosition,
      verticalOffset,
      shouldShowChildrenOnly,
      textWrap,
      calculatedPointerWidth } =
    this.state;

    const Triangle = Triangles[side];

    return shouldShowChildrenOnly ?
    children : /*#__PURE__*/

    React.createElement(Container, null, /*#__PURE__*/
    React.createElement(AnimationContainer, null, /*#__PURE__*/
    React.createElement(TextContainer, {
      snapPosition: snapPosition,
      side: side,
      pointerOffset: pointerOffset,
      verticalOffset: verticalOffset,
      ref: this.textContainerRef }, /*#__PURE__*/

    React.createElement(Wrap, { zIndex: zIndex, width: calculatedPointerWidth, textWrap: textWrap }, /*#__PURE__*/
    React.createElement(Text, null, text), /*#__PURE__*/
    React.createElement(Triangle, {
      style: {
        [snapPosition === SnapPositions.RIGHT ? 'right' : 'left']:
        arrowOffset },

      side: side,
      fill: theme.colors.secondary,
      zIndex: zIndex })))), /*#__PURE__*/




    React.createElement(ChildrenContainer, { ref: this.childrenContainerRef }, children));


  }}


const ThemedPointer = /*#__PURE__*/withTheme(Pointer);

export default ThemedPointer;